import { render, staticRenderFns } from "./VolumeDiscountTypePicker.vue?vue&type=template&id=090b1eb8"
import script from "./VolumeDiscountTypePicker.vue?vue&type=script&lang=js"
export * from "./VolumeDiscountTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports